//================================================================
//  Sub-Component: TableCell is a sub component of 'SubnetsAllocationGuide.js' component
//================================================================

//  Purpose: Inline editing of a cell

//  Properties:

//  Example:
//    <TableCell></TableCell>    

//================================================================

import React, { useEffect } from 'react'


export default function TableCell({
    index,
    row,
    objectKey,
    heightKey,
    allocationState,
    setAllocationState,
    disabled
}) {

    //------------------------------------------------------
    //  Functions
    //------------------------------------------------------

    // Due to the CRAP textarea's fit-content height support, this code dynamatically increases the hight of the element on keyDown
    function textAreaAdjust() {

        const textarea = document.getElementById(`${index}-${objectKey}`);

        textarea.style.height = "1px";
        textarea.style.height = `${25 + textarea.scrollHeight}px`;

    };

    //------------------------------------------------------
    //  useEffect
    //------------------------------------------------------

    // onLoad
    //  - Take the current height from the useReducer and update the field
    useEffect(() => {

        const textarea = document.getElementById(`${index}-${objectKey}`);
        textarea.style.height = `${25 + textarea.scrollHeight}px`;

    }, [index, objectKey]);

    //------------------------------------------------------
    //  HTML
    //------------------------------------------------------

    return (

        <textarea
            id={`${index}-${objectKey}`}
            className={`p-2 outline-none overflow-hidden resize-none w-full disabled:bg-white h-[${row[heightKey]}]`}
            disabled={disabled}
            onKeyUp={(e) => textAreaAdjust(e)}
            onChange={(e) => {
            
                // Save the row height
                const textarea = document.getElementById(`${index}-${objectKey}`);
                row[heightKey] = `${25 + textarea.scrollHeight}px`;

                // Save the row value
                row[objectKey] = e.target.value;

                // Save to usReducer
                allocationState.rows[index] = row;
                setAllocationState({
                    'rows': [...allocationState.rows],
                    'preventSave': false,
                });

            }}
            value={row[objectKey]}
        ></textarea>

    )

}
